<script lang="ts">
import { createVNode, resolveComponent, defineComponent, computed, type CSSProperties } from 'vue'
import { Icon as IconifyIcon } from '@iconify/vue/dist/offline'
import Svg from '/@/components/icon/svg/index.vue'
import { isExternal } from '/@/utils/url'

export default defineComponent({
	name: 'Icon',
	components: { IconifyIcon },
	props: {
		name: {
			type: String,
			required: true,
		},
		size: {
			type: String,
			default: '18px',
		},
		color: {
			type: String,
			default: '#000000',
		},
	},
	setup(props) {
		const iconStyle = computed((): CSSProperties => {
			const { size, color } = props
			let s = `${size.replace('px', '')}px`
			return {
				fontSize: s,
				color: color,
			}
		})

		// Element Plus 图标
		if (props.name.indexOf('el-icon-') === 0) {
			return () => createVNode('el-icon', { class: 'icon el-icon', style: iconStyle.value }, [createVNode(resolveComponent(props.name))])
		}
		// 本地 SVG 图标或外部链接
		else if (props.name.indexOf('local-') === 0 || isExternal(props.name)) {
			return () => createVNode(Svg, { name: props.name, size: props.size, color: props.color })
		}
		// Iconify 离线图标 (通过 ':' 或 '/' 判断，如 ep:add-location)
		else if (props.name.includes(':') || props.name.includes('/')) {
			const iconName = props.name.replace(':', '/')
			return () =>
				createVNode(IconifyIcon, {
					icon: iconName,
					style: iconStyle.value,
					class: 'icon',
				})
		}
		// Font Awesome 等字体图标
		else {
			return () => createVNode('i', { class: [props.name, 'icon'], style: iconStyle.value })
		}
	},
})
</script>
